import { QuestionCircle20Regular, TaskListLtr20Regular } from "@fluentui/react-icons"
import Select from "@/components/Select";
import { AnswerCategory } from "@/schema/console/evaluation-reports/AnswerCategory";
import { useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  category: AnswerCategory
  onSubCategoryChange: (subCategoryId: number) => void
}

function CategoryHeader({
  category,
  onSubCategoryChange
}: Props) {

  const subCategoryCount = category.answer_sub_categories?.length || 0
  const questionCount = category.answer_sub_categories?.reduce((acc, subCategory) => acc + subCategory.answer_contents.length, 0) || 0
  const subCategoryOptions = category.answer_sub_categories?.map(subCategory => ({ label: subCategory.content, value: String(subCategory.id) }))
  const [selectedSubCategory, setSelectedSubCategory] = useState(subCategoryOptions[0])
  const { t } = useTranslation();
  return (
    <div
      className=" flex flex-row justify-between items-center">
      <div
        className=" flex flex-col space-y-2">
        <p
          className=" text-lg font-bold text-cool-gray-700">
          {category.content}
        </p>
        <div
          className=" flex flex-row space-x-6">
          <div
            className=" flex flex-row space-x-[6px] items-center">
            <TaskListLtr20Regular />
            <p
              className=" text-sm font-normal text-cool-gray-600">
              {`${subCategoryCount} ${t("sub-categories")}`}
            </p>
          </div>
          <div
            className=" flex flex-row space-x-[6px] items-center">
            <QuestionCircle20Regular />
            <p
              className=" text-sm font-normal text-cool-gray-600">
              {`${questionCount} ${t("questions")}`}
            </p>
          </div>
        </div>
      </div>
      <div
        className=" flex flex-col space-y-1">
        <p
          className=" text-sm font-medium text-cool-gray-600">
          {t("sub-categories")}
        </p>
        <Select
          width="200px"
          options={subCategoryOptions}
          value={selectedSubCategory.value}
          className="rounded-md border bg-white"
          onChange={(value) => {
            setSelectedSubCategory(subCategoryOptions.find(option => option.value === value)!)
            onSubCategoryChange(Number(value))
          }}
        />
      </div>
    </div>
  )
}

export default CategoryHeader